import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthUtil } from '@app/common/util/auth.util';
import { CommonUtils } from '@app/common/util/common.util';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private _router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const isLogined = AuthUtil.isLogined();
    const url = state.url;
    // check if shopping cart and have link order
    if(!isLogined && url.includes("shopping-mall") && CommonUtils.isLinkOrderUser()){
      return CommonUtils.isLinkOrderUser();
    }
    if (!isLogined) {
      this._router.navigate(["/login"]);
    }
    return isLogined;
  }
}
